
(() => {
  if (window.__idlConsentInstalled) return;
  window.__idlConsentInstalled = true;

  const root = window.Shopify?.routes?.root || "/";
  const keyPolicies = "IDL - Politiques acceptees";
  const keyDigital = "IDL - Consentement numerique";
  const keyDate = "IDL - Date consentement UTC";
  const keyVersion = "IDL - Version consentement";
  const processing = new WeakSet();

  async function proceed(button) {
    const block = button.closest(".cart__ctas")
      ?.parentElement
      ?.querySelector("[data-idl-consent]");

    if (!block?.matches("[data-idl-consent]") || processing.has(button)) return;

    const policies = block.querySelector("[data-idl-policies]");
    const digital = block.querySelector("[data-idl-digital]");
    const needsDigital = block.dataset.digitalRequired === "true";
    const error = block.querySelector("[data-idl-error]");

    if (!policies?.checked || (needsDigital && !digital?.checked)) {
      if (error) {
        error.textContent = "Veuillez accepter les conditions applicables avant de continuer.";
        error.hidden = false;
      }

      const missing = !policies?.checked ? policies : digital;
      missing?.focus();
      return;
    }

    processing.add(button);
    button.disabled = true;
    button.setAttribute("aria-busy", "true");

    try {
      const readResponse = await fetch(`${root}cart.js`, {
        credentials: "same-origin",
        cache: "no-store"
      });

      if (!readResponse.ok) {
        throw new Error("Lecture du panier impossible");
      }

      const cart = await readResponse.json();

      const signature = cart.items
        .map(item => `${item.key}~${item.quantity}`)
        .join("|");

      if (signature !== block.dataset.cartSignature) {
        throw new Error(
          "Le panier a changé. Actualisez la page et acceptez à nouveau les conditions."
        );
      }

      const attributes = {
        [keyPolicies]: "Oui",
        [keyDigital]: needsDigital ? "Oui" : "Non applicable",
        [keyDate]: new Date().toISOString(),
        [keyVersion]: "2026-10-13-v1"
      };

      const updateResponse = await fetch(`${root}cart/update.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes })
      });

      if (!updateResponse.ok) {
        throw new Error("Enregistrement du consentement impossible");
      }

      const updated = await updateResponse.json();

      if (
        Object.entries(attributes).some(
          ([key, value]) => updated.attributes?.[key] !== value
        )
      ) {
        throw new Error("Enregistrement du consentement non confirmé");
      }

      window.location.assign("/checkout");

    } catch (err) {
      if (error) {
        error.textContent =
          err.message || "Un problème est survenu. Réessayez.";
        error.hidden = false;
      }

      processing.delete(button);
      button.disabled = false;
      button.removeAttribute("aria-busy");
    }
  }

  function intercept(event, button) {
    if (!button) return;

    const block = button.closest(".cart__ctas")
      ?.parentElement
      ?.querySelector("[data-idl-consent]");

    if (!block?.matches("[data-idl-consent]")) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    void proceed(button);
  }

  document.addEventListener("click", event => {
    intercept(
      event,
      event.target.closest?.('button[name="checkout"]')
    );
  }, true);

  document.addEventListener("submit", event => {
    intercept(
      event,
      event.submitter?.matches?.('button[name="checkout"]')
        ? event.submitter
        : null
    );
  }, true);
})();
